<template>
	<div class="integral-goods-details-container">
		<div class="backBox" @click="handleClose">
			<img class="backIcon" src="../assets/Personal/iconI.png" />
			返回
		</div>
		<div class="statusBox">
			<div class="status">
				{{details.status == 1 ? '已处理' : '未处理'}}
				<div class="time">申请时间：{{details.create_time ? details.create_time : ''}}</div>
			</div>
			¥ {{details.price ? details.price : ''}}
		</div>
		<div class="infoItemBox">
			<div class="infoItemTitle">
				订单信息
			</div>
			<div class="infoItem">
				订单类型
				<div class="itemContent">
					{{details.type && details.type == 1 ? '图片订单' : details.type && details.type == 3 ? '定制订单' : '周边订单'}}
				</div>
			</div>
			<div class="infoItem">
				订单编号
				<div class="itemContent">
					{{details.order && details.order.order_sn ? details.order.order_sn : ''}}
				</div>
			</div>
			<div class="infoItem">
				订单金额
				<div class="itemContent">
					¥{{details.order && details.order.order_price ? details.order.order_price : ''}}
				</div>
			</div>
			<div class="infoItem">
				实付金额
				<div class="itemContent">
					¥{{details.order && details.order.pay_price ? details.order.pay_price : ''}}
				</div>
			</div>
		</div>
		<div class="infoItemBox">
			<div class="infoItemTitle">
				发票信息
			</div>
			<div class="infoItem">
				开票类型
				<div class="itemContent">{{details.lx_type == 1 ? '个人' : '企业'}}</div>
			</div>
			<div class="infoItem" v-if="details.lx_type == 2">
				企业名称
				<div class="itemContent">{{details.qy_name ? details.qy_name : ''}}</div>
			</div>
			<div class="infoItem" v-if="details.lx_type == 2">
				公司税号
				<div class="itemContent">{{details.qy_num ? details.qy_num : ''}}</div>
			</div>
			<div class="infoItem">
				真实姓名
				<div class="itemContent">{{details.lxr ? details.lxr : ''}}</div>
			</div>
			<div class="infoItem">
				联系方式
				<div class="itemContent">{{details.phone ? details.phone : ''}}</div>
			</div>
			<div class="infoItem">
				邮箱
				<div class="itemContent">{{details.email ? details.email : ''}}</div>
			</div>
		</div>
		<div class="menu" v-if="details.status == 1">
			<div class="menuItem">
				<el-image style="width: 2.4rem;height: .52rem;position: absolute;top: 0;left: 0;opacity: 0;"
					:src="details.img" :preview-src-list="[details.img]" v-if="details.img">
				</el-image>
				<i class="el-icon-view"></i>
				查看发票
			</div>
			<div class="menuItem" @click="download">
				<i class="el-icon-download"></i>
				下载发票
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			goods: {
				type: Object,
				default: () => {}
			}
		},
		watch: {
			goods: {
				handler(newValue) {
					console.log(newValue)
					this.goodsDetails()
				},
				deep: true
			}
		},
		data() {
			return {
				details: {},
			}
		},
		methods: {
			handleClose() {
				this.$emit('close')
			},
			goodsDetails() {
				this.$api.post('UserD/invoice_details', {
					id: this.goods.id
				}).then(res => {
					if (res.code == 1) {
						this.details = res.data
					}
				}).catch(err => {
					console.log(err);
				})
			},
			download() {
				var ua = navigator.userAgent.toLowerCase() || navigator.vendor.toLowerCase() || window.opera.toLowerCase()
				var isAndroid = ua.indexOf('android') > -1 || ua.indexOf('harmony') > -1
				var isIOS = /iphone|ipad|ipod/.test(ua)
				var isMobile = isAndroid || isIOS
				if (isMobile) {
					this.downloadImageToAlbum(this.details.img);
				} else {
					window.open(this.details.img)
				}
			},
			downloadImageToAlbum(url, fileName = "invoice.png") {
				console.log(fileName)
				// const ua = navigator.userAgent;
				// const isIOS = /iP(ad|hone|od)/.test(ua);
				// const isAndroid = /Android/i.test(ua);
				// const isSafari = /Safari/i.test(ua) && !/Chrome|CriOS|FxiOS/i.test(ua);
				// const isWeChatOrUCOrQQ = /MicroMessenger|UCBrowser|QQBrowser/i.test(ua);

				// // ✅ PC / 安卓浏览器 / iOS Safari
				// if ((!isIOS && !isAndroid) || (isAndroid && !isWeChatOrUCOrQQ) || (isIOS && isSafari)) {
				// 	this._downloadByA(url, fileName);
				// 	return;
				// }

				// ❌ iOS / 安卓 微信、UC、QQ → 长按保存
				this._showLongPressSave(url);
			},

			// ====== 方式一：a.download 下载 ======
			_downloadByA(url, fileName) {
				fetch(url)
					.then(res => res.blob())
					.then(blob => {
						const a = document.createElement("a");
						const blobUrl = URL.createObjectURL(blob);
						a.href = blobUrl;
						a.download = fileName;
						document.body.appendChild(a);
						a.click();
						document.body.removeChild(a);
						setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
					});
			},

			// ====== 方式二：长按保存 ======
			_showLongPressSave(url) {
				const mask = document.createElement("div");
				mask.style.cssText = `
			      position:fixed;
			      inset:0;
			      background:rgba(0,0,0,.85);
			      z-index:9999;
			      display:flex;
			      flex-direction:column;
			      justify-content:center;
			      align-items:center;
			    `;

				const img = document.createElement("img");
				img.src = url;
				img.style.maxWidth = "90%";
				img.style.borderRadius = "6px";

				const tip = document.createElement("div");
				tip.innerText = "长按图片保存到相册";
				tip.style.cssText = "color:#fff;margin-top:12px;font-size:16px;";

				mask.appendChild(img);
				mask.appendChild(tip);
				document.body.appendChild(mask);

				mask.onclick = () => document.body.removeChild(mask);
			}
		}
	}
</script>

<style lang="scss" scoped>
	.integral-goods-details-container {
		width: 100%;
		background: #FFFFFF;
		padding: .24rem .4rem;
		display: flex;
		flex-direction: column;
	}

	.backBox {
		display: flex;
		align-items: center;
		font-weight: 400;
		font-size: .14rem;
		color: #000000;
		cursor: pointer;

		.backIcon {
			width: .06rem;
			height: .1rem;
			margin-right: .06rem;
		}
	}

	.statusBox {
		margin-top: .16rem;
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-weight: 700;
		font-size: .24rem;
		color: #FF0000;

		.status {
			display: flex;
			flex-direction: column;
			font-weight: 700;
			font-size: .24rem;
			color: #000000;

			.time {
				font-weight: 400;
				font-size: .14rem;
				color: #333333;
			}
		}
	}

	.infoItemBox {
		display: flex;
		flex-direction: column;
		margin-top: .16rem;
		padding-top: .16rem;
		border-top: .01rem solid #CCCCCC;

		.infoItemTitle {
			font-weight: 600;
			font-size: .16rem;
			color: #333333;
		}

		.infoItem {
			margin-top: .08rem;
			display: flex;
			align-items: center;
			justify-content: space-between;
			font-weight: 400;
			font-size: .16rem;
			color: #333333;

			.itemContent {
				font-weight: 600;
			}
		}
	}

	.menu {
		display: flex;
		align-items: center;
		margin: .32rem auto .16rem;

		.menuItem {
			margin: 0 .24rem;
			display: flex;
			align-items: center;
			justify-content: center;
			font-weight: 500;
			font-size: .16rem;
			color: #252525;
			width: 2.4rem;
			height: .52rem;
			background: #EFD8B8;
			border-radius: .06rem;
			line-height: .52rem;
			cursor: pointer;
			position: relative;

			i {
				margin-right: .06rem;
			}
		}
	}
</style>